<!-- <app-header></app-header> -->
<!-- <app-mobile-not-supported></app-mobile-not-supported> -->
<div class="main-container" [style.overflow]="userDepartment === 'MARKETING' ? 'hidden' : 'auto'">
  <!-- Mobile Backdrop Overlay -->
  @if (isMobileNavOpen) {
  <div class="mobile-nav-backdrop d-md-none" (click)="toggleMobileNav()"></div>
  }

  <div class="side-nav-banner" [class.mobile-open]="isMobileNavOpen">

    <div class="sidebar-logo-container">
      <a routerLink="/home" class="logo-link">
        <img src="../../assets/login/header-logo.png" class="sidebar-logo" alt="Logo" />
      </a>
    </div>
    <div class="side-menu">
      <ul>
        @for (item of menuItems; track item.id) {

        @if (
        item.id !== 'calendar' ||
        (item.id === 'calendar' && !calendarView)
        ) {

        <li (click)="navigateTo(item)" [class.active]="activeMenu === item.id"
          [class.all-projects-item]="item.id === 'all'">

          <div class="menu-icon-wrapper">
            @if(item.id === 'all') {
            <i class="material-symbols-outlined all-projects-icon">
              apps
            </i>
            } @else if(item.id === 'outbound') {
            <i class="material-symbols-outlined nav-mat-icon" style="font-size: 28px; font-weight: 500;">
              outbound
            </i>
            } @else {
            <img width="25" height="25" [src]="item.icon" class="menu-icon-img" [style.filter]="getIconFilter(item.id)"
              alt="icon" />
            }

            @if (item.id === 'chat' && (unreadCount$ | async); as totalUnreadCount) {
            @if (totalUnreadCount > 0) {
            <span class="chat-nav-badge">
              {{ totalUnreadCount > 99 ? '99+' : totalUnreadCount }}
            </span>
            }
            }
          </div>

          <span class="nav-label">{{ item.label }}</span>
        </li>

        }

        }
      </ul>

    </div>
  </div>
  <main class="lead-track-content">
    <router-outlet></router-outlet>
  </main>
</div>